export default "<app-fivebox></app-fivebox>\n<app-footer></app-footer>"